const { REACT_APP_MODE } = process.env;

const configs = {
  dev: {
    DEV: true,
    // API_URL: 'https://sortpak-ghost-dev.ghost-services.com',
    API_URL: 'https://portal-api.sortpak.com',
  },
  prod: {
    PROD: true,
    // API_URL: 'https://sortpak-ghost-dev.ghost-services.com',
    API_URL: 'https://portal-api.sortpak.com',
  },
};

export default configs[REACT_APP_MODE] || configs.prod;
